// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;I am alarmed at the voice of the enemy&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and at the clamour of the wicked;<br> </p> </div></div>";
// Exports
module.exports = code;